/* eslint-disable camelcase */
import qs from 'qs';

export default (location) => {
  const search = location ? location.search : window.location.search;
  let queryStringParams = qs.parse(search, { ignoreQueryPrefix: true });
  const { epoi = null, sf_epoi = null } = queryStringParams;
  const qsLocation = epoi || sf_epoi;
  if (qsLocation) {
    try {
      const qsToParse = atob(qsLocation);
      const splittedParams = qsToParse.split('|');
      if (splittedParams.length > 1) {
        const lat = splittedParams[0];
        const lng = splittedParams[1];
        if (Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))) {
          queryStringParams = { ...queryStringParams, lat, lng };
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Unable to parse epoi from queryStrig, falling back to default');
    }
  }
  return queryStringParams;
};
